"use strict";
/**
 * A mock implementation of Node's util package. This module implements only
 * what is actually used in salve.
 *
 * @author Louis-Dominique Dubeau
 * @license MPL 2.0
 * @copyright Mangalam Research Center for Buddhist Languages
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A mock of Node's ``util.inspect``.
 */
function inspect(x) {
    if (x === undefined) {
        return "undefined";
    }
    if (x === null) {
        return "null";
    }
    return x.toString();
}
exports.inspect = inspect;
//  LocalWords:  Mangalam MPL Dubeau util
//# sourceMappingURL=util.js.map